import { useQuery } from "@tanstack/react-query";
import pulseService from "@stringf/services/pulse";

/** Matches the server's `Cache-Control: max-age=300` and in-process cache. */
export const PULSE_STALE_MS = 5 * 60_000;

export const pulseKeys = {
  all: ["pulse"] as const,
};

/**
 * The Pulse for the landing page. No retry and no refetch on focus: a 503
 * means "no snapshot yet" and the caller hides the section, and the figures
 * move on a five-minute clock, not a tab-focus one.
 */
export function usePulseQuery() {
  return useQuery({
    queryKey: pulseKeys.all,
    queryFn: () => pulseService.getPulse(),
    staleTime: PULSE_STALE_MS,
    retry: false,
    refetchOnWindowFocus: false,
  });
}
